import { render, staticRenderFns } from "./CarePlan.vue?vue&type=template&id=69998d70&"
import script from "./CarePlan.vue?vue&type=script&lang=js&"
export * from "./CarePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports